import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assertAndContinue} from 'Asserts';
import {PANE_MARGIN} from 'insights/InsightsConstants';
import {RED} from 'ui-library/Colors';
import Pane from 'ui-library/pane/Pane';

export function shouldRenderSQLConsole(
  props: Pick<SQLConsoleProps, 'errorMessage' | 'rawSQLQuery'>
): boolean {
  return props.errorMessage != null || props.rawSQLQuery != null;
}

export interface SQLConsoleProps {
  errorMessage: string | null;
  rawSQLQuery: string | null;
}

export default function SQLConsole(props: SQLConsoleProps): JSX.Element | null {
  assertAndContinue(shouldRenderSQLConsole(props), 'Caller should check shouldRenderSQLConsole');
  return (
    <Pane title="Console" fitContent={true}>
      {props.errorMessage && (
        <pre className={css(styles.errorMessage, styles.contentMargin)}>{props.errorMessage}</pre>
      )}
      {props.rawSQLQuery && (
        <pre className={css(props.errorMessage == null ? styles.contentMargin : styles.partialContentMargin)}>
          ----- Executed query -----{'\n'}
          {props.rawSQLQuery}
        </pre>
      )}
    </Pane>
  );
}

const styles = StyleSheet.create({
  errorMessage: {
    color: RED,
  },
  contentMargin: {
    margin: PANE_MARGIN,
  },
  partialContentMargin: {
    marginTop: 0,
    marginRight: PANE_MARGIN,
    marginBottom: PANE_MARGIN,
    marginLeft: PANE_MARGIN,
  },
});
